<template>
    <div class="mb-2">
        <div class="card shadow-sm overflow-hidden">
            <div class="card-body px-3 pt-2 pb-3">
                <b-form-group class="mb-2"
                              v-bind:label-for="`sku-name-${ index }`"
                              v-if="['vending-admin', 'vending-vendor'].includes(userRole)">
                    <template v-slot:label>
                        SKU名稱
                    </template>
                    <b-form-input class="bg-light"
                                  size="sm"
                                  type="text"
                                  required
                                  v-bind:id="`sku-name-${ index }`"
                                  v-model="name">
                    </b-form-input>
                </b-form-group>
                <b-form-group class="mb-0"
                              v-bind:label-for="`sku-code-${ index }`"
                              v-if="['vending-admin', ].includes(userRole)">
                    <template v-slot:label>
                        SKU代號
                    </template>
                    <b-form-input class="bg-light"
                                  size="sm"
                                  type="text"
                                  required
                                  v-bind:id="`sku-code-${ index }`"
                                  v-model="code">
                    </b-form-input>
                </b-form-group>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        BFormGroup,
        BFormInput,
    } from "bootstrap-vue";

    export default {
        name: "SKUCard",
        components: {
            BFormGroup,
            BFormInput,
        },
        props: {
            "value": {
                "type": Object,
                "required": true,
            },

            "index": {
                "type": String,
                "required": true,
            },
        },
        data () {
            return {

            };
        },
        computed: {
            userRole () {
                return this.$store.state.user.user.role;
            },

            name: {
                "get" () {
                    return this.value ?
                        this.value.name :
                        "";
                },
                "set" (val) {
                    const temp = Object.assign({}, this.value);
                    temp.name = val;
                    this.$emit(
                        "input",
                        temp
                    );
                },
            },

            code: {
                "get" () {
                    return this.value ?
                        this.value.code :
                        "";
                },
                "set" (val) {
                    const temp = Object.assign({}, this.value);
                    temp.code = val;
                    this.$emit(
                        "input",
                        temp
                    );
                },
            },
        },
        methods: {

        },
    }
</script>

<style lang="scss" scoped>

</style>
